import React, { useState } from 'react';
import get from 'lodash/get';
import { Row, Col, Form, Input, Spin, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { userMangement } from '../../redux/actions/authActions';
import SignupImage from '../../assets/common/login.png';
import { LOGIN } from '../../constants/routes';
import SignUpTimer from '../../components/signUpTimer';

const SignUpScreen = () => {
  const [loading, setLoading] = useState(false);
  const [signupStatus, setSignupStatus] = useState({
    showSignup: true,
    showVerify: false,
    showSignupSuccess: false,
  });
  const [otpToken, setOtpToken] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const onFinish = (values) => {
    setLoading(true);
    delete values.confirm;
    dispatch(userMangement('pub.create.brand', values))
      .then((res) => {
        setLoading(false);
        setSignupStatus({
          showSignup: false,
          showVerify: true,
          showSignupSuccess: false,
        });
        setOtpToken(get(res, ['data', 'otp_token']));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinishVerify = (values) => {
    setLoading(true);
    dispatch(
      userMangement('pub.otp.verify', { ...values, otp_token: otpToken })
    )
      .then(() => {
        setLoading(false);
        setSignupStatus({
          showSignup: false,
          showVerify: false,
          showSignupSuccess: true,
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Spin spinning={loading}>
      <Row style={{ alignItems: 'center' }}>
        <Col span={16} style={{ textAlign: 'center' }}>
          <img src={SignupImage} alt="" />
        </Col>
        <Col span={8}>
          <div className="login-container">
            {get(signupStatus, 'showSignup') && (
              <>
                <div className="heading">Signup</div>
                <div className="login-form">
                  <Form
                    name="basic"
                    layout="vertical"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    autoComplete="off"
                    requiredMark={false}
                  >
                    <div className="mt-20">
                      <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your name',
                          },
                          {
                            pattern: /^[a-zA-Z ]*$/,
                            message: 'Enter a valid alphabet',
                          },
                          {
                            min: 3,
                            message: 'Name must have minimum 3 characters',
                          },
                          {
                            max: 100,
                            message: 'Name cannot be more than 100 characters',
                          },
                        ]}
                      >
                        <Input placeholder="Enter your name" />
                      </Form.Item>
                    </div>

                    <div className="mt-20">
                      <Form.Item
                        label="Brand Name"
                        name="brand_name"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your brand name',
                          },
                          {
                            min: 3,
                            message: 'Brand Name must be minimum 3 characters',
                          },
                        ]}
                      >
                        <Input placeholder="Enter Brand Name" />
                      </Form.Item>
                    </div>

                    <div className="mt-20">
                      <Form.Item
                        label="Email id "
                        name="email"
                        className="form-item"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your registered email!',
                          },
                          {
                            type: 'email',
                            message: 'Please Input valid email',
                          },
                        ]}
                      >
                        <Input placeholder="Enter Email" />
                      </Form.Item>
                    </div>

                    <div className="mt-20">
                      <Form.Item
                        label="Phone Number"
                        name="mobile"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your phone number',
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: 'Please enter a valid integer',
                          },
                          {
                            min: 10,
                            message: 'Mobile number must contain 10 digits',
                          },
                          {
                            max: 10,
                            message:
                              'Mobile number cannot be more than 10 digits',
                          },
                        ]}
                      >
                        <Input placeholder="Enter Mobile No." />
                      </Form.Item>
                    </div>

                    <div className="mt-20">
                      <Form.Item
                        label="Create Password"
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your password!',
                          },
                          {
                            min: 12,
                            message: 'Password must be atleast 12 characters',
                          },
                        ]}
                      >
                        <Input.Password placeholder="Enter your password" />
                      </Form.Item>
                    </div>

                    <div className="mt-20">
                      <Form.Item
                        name="confirm"
                        label="Confirm Password"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: 'Please confirm your password',
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue('password') === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  'The two passwords that you entered do not match'
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password placeholder="Confirm your password" />
                      </Form.Item>
                    </div>

                    <div className="mt-20">
                      <Form.Item>
                        <Button type="primary" block htmlType="submit">
                          Sign Up
                        </Button>
                      </Form.Item>
                    </div>

                    <Button
                      type="link"
                      block
                      className="forgot-password"
                      onClick={() => {
                        history.push(LOGIN);
                      }}
                    >
                      Already have an account ?
                      <span className="clickhere"> Login here</span>
                    </Button>
                  </Form>
                </div>
              </>
            )}

            {get(signupStatus, 'showVerify') && (
              <>
                <div className="heading">Verify OTP</div>
                <div className="login-form">
                  <Form
                    name="basic"
                    layout="vertical"
                    initialValues={{ remember: true }}
                    onFinish={onFinishVerify}
                    autoComplete="off"
                    requiredMark={false}
                  >
                    <div className="mt-20">
                      <Form.Item
                        label="OTP"
                        name="code"
                        rules={[
                          {
                            required: true,
                            message: 'Please input the verifucation OTP',
                          },
                          {
                            min: 6,
                            message: 'OTP must be minimum 6 character',
                          },
                          {
                            max: 6,
                            message: 'OTP cannot be more than 6 character',
                          },
                        ]}
                      >
                        <Input placeholder="Enter OTP" />
                      </Form.Item>
                    </div>

                    <SignUpTimer otpToken={otpToken} />

                    <div className="mt-40">
                      <Form.Item>
                        <Button type="primary" block htmlType="submit">
                          Verify
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </div>
              </>
            )}

            {get(signupStatus, 'showSignupSuccess') && (
              <>
                <div className="heading" style={{ justifyContent: 'center' }}>
                  Success!
                </div>
                <div
                  className="mt-40 text-theme-color"
                  style={{ textAlign: 'center' }}
                >
                  <div>You have succesfully registerd yourself.</div>
                  <div>Now you can Login</div>

                  <div className="mt-40">
                    <Button
                      className="default-btn"
                      block
                      onClick={() => {
                        history.push(LOGIN);
                      }}
                    >
                      Log In
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default SignUpScreen;
